import { Api as api } from "../api";
const prefix = "/config";
// const prefix = "";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    vehicleOperationServiceV1ListVehicleOperations: build.query<
      VehicleOperationServiceV1ListVehicleOperationsApiResponse,
      VehicleOperationServiceV1ListVehicleOperationsApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/vehicle-operations`,
        params: {
          page: queryArg.page,
          size: queryArg.size,
          sort: queryArg.sort,
          order: queryArg.order,
          status: queryArg.status,
          vehicle_type_name: queryArg.vehicleTypeName,
          vehicle_model_name: queryArg.vehicleModelName,
          fuel_type_name: queryArg.fuelTypeName,
          trip_type_name: queryArg.tripTypeName,
          fuel_usage: queryArg.fuelUsage,
          avg_speed: queryArg.avgSpeed,
          working_hours: queryArg.workingHours,
          created_at_from: queryArg.createdAtFrom,
          created_at_to: queryArg.createdAtTo,
          updated_at_from: queryArg.updatedAtFrom,
          updated_at_to: queryArg.updatedAtTo,
        },
      }),
    }),
    vehicleOperationServiceV1BatchCreateVehicleOperation: build.mutation<
      VehicleOperationServiceV1BatchCreateVehicleOperationApiResponse,
      VehicleOperationServiceV1BatchCreateVehicleOperationApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/vehicle-operations`,
        method: "POST",
        body: queryArg.vehicleOperationV1BatchCreateVehicleOperationReq,
      }),
    }),
    vehicleOperationServiceV1ActivateVehicleOperations: build.mutation<
      VehicleOperationServiceV1ActivateVehicleOperationsApiResponse,
      VehicleOperationServiceV1ActivateVehicleOperationsApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/vehicle-operations/activate`,
        method: "PATCH",
        body: queryArg.vehicleOperationV1VehicleOperationBulkStatusChangeReq,
      }),
    }),
    vehicleOperationServiceV1DeactivateVehicleOperations: build.mutation<
      VehicleOperationServiceV1DeactivateVehicleOperationsApiResponse,
      VehicleOperationServiceV1DeactivateVehicleOperationsApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/vehicle-operations/deactivate`,
        method: "PATCH",
        body: queryArg.vehicleOperationV1VehicleOperationBulkStatusChangeReq,
      }),
    }),
    vehicleOperationServiceV1GetVehicleOperationFuelTypes: build.query<
      VehicleOperationServiceV1GetVehicleOperationFuelTypesApiResponse,
      VehicleOperationServiceV1GetVehicleOperationFuelTypesApiArg
    >({
      query: () => ({ url: `${prefix}/v1/vehicle-operations/fuel-types` }),
    }),
    vehicleOperationServiceV1GetVehicleOperationTripTypes: build.query<
      VehicleOperationServiceV1GetVehicleOperationTripTypesApiResponse,
      VehicleOperationServiceV1GetVehicleOperationTripTypesApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/vehicle-operations/trip-types`,
        params: {
          vehicle_type_id: queryArg.vehicleTypeId,
        },
      }),
    }),
    vehicleOperationServiceV1GetVehicleOperationVehicleAuxiliaries: build.query<
      VehicleOperationServiceV1GetVehicleOperationVehicleAuxiliariesApiResponse,
      VehicleOperationServiceV1GetVehicleOperationVehicleAuxiliariesApiArg
    >({
      query: () => ({ url: `${prefix}/v1/vehicle-operations/vehicle-auxiliaries` }),
    }),
    vehicleOperationServiceV1GetVehicleOperationVehicleModels: build.query<
      VehicleOperationServiceV1GetVehicleOperationVehicleModelsApiResponse,
      VehicleOperationServiceV1GetVehicleOperationVehicleModelsApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/vehicle-operations/vehicle-models`,
        params: {
          vehicle_type_id: queryArg.vehicleTypeId,
        },
      }),
    }),
    vehicleOperationServiceV1GetVehicleOperationVehicleTypes: build.query<
      VehicleOperationServiceV1GetVehicleOperationVehicleTypesApiResponse,
      VehicleOperationServiceV1GetVehicleOperationVehicleTypesApiArg
    >({
      query: () => ({ url: `${prefix}/v1/vehicle-operations/vehicle-types` }),
    }),
    vehicleOperationServiceV1GetVehicleOperation: build.query<
      VehicleOperationServiceV1GetVehicleOperationApiResponse,
      VehicleOperationServiceV1GetVehicleOperationApiArg
    >({
      query: (queryArg) => ({ url: `${prefix}/v1/vehicle-operations/${queryArg.id}` }),
    }),
    vehicleOperationServiceV1UpdateVehicleOperation: build.mutation<
      VehicleOperationServiceV1UpdateVehicleOperationApiResponse,
      VehicleOperationServiceV1UpdateVehicleOperationApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/vehicle-operations/${queryArg.id}`,
        method: "PUT",
        body: queryArg.vehicleOperationServiceV1UpdateVehicleOperationBody,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as vehicleOperationApi };
export type VehicleOperationServiceV1ListVehicleOperationsApiResponse =
  /** status 200 A successful response. */ VehicleOperationV1ListVehicleOperationsRes;
export type VehicleOperationServiceV1ListVehicleOperationsApiArg = {
  page?: number;
  size?: number;
  sort?: string;
  order?: string;
  status?: string;
  vehicleTypeName?: string;
  vehicleModelName?: string;
  fuelTypeName?: string;
  tripTypeName?: string;
  fuelUsage?: number;
  avgSpeed?: number;
  workingHours?: number;
  createdAtFrom?: string;
  createdAtTo?: string;
  updatedAtFrom?: string;
  updatedAtTo?: string;
};
export type VehicleOperationServiceV1BatchCreateVehicleOperationApiResponse =
  /** status 200 A successful response. */ VehicleOperationV1VehicleOperationMessageRes;
export type VehicleOperationServiceV1BatchCreateVehicleOperationApiArg = {
  vehicleOperationV1BatchCreateVehicleOperationReq: VehicleOperationV1BatchCreateVehicleOperationReq;
};
export type VehicleOperationServiceV1ActivateVehicleOperationsApiResponse =
  /** status 200 A successful response. */ VehicleOperationV1VehicleOperationBulkStatusChangeRes;
export type VehicleOperationServiceV1ActivateVehicleOperationsApiArg = {
  vehicleOperationV1VehicleOperationBulkStatusChangeReq: VehicleOperationV1VehicleOperationBulkStatusChangeReq;
};
export type VehicleOperationServiceV1DeactivateVehicleOperationsApiResponse =
  /** status 200 A successful response. */ VehicleOperationV1VehicleOperationBulkStatusChangeRes;
export type VehicleOperationServiceV1DeactivateVehicleOperationsApiArg = {
  vehicleOperationV1VehicleOperationBulkStatusChangeReq: VehicleOperationV1VehicleOperationBulkStatusChangeReq;
};
export type VehicleOperationServiceV1GetVehicleOperationFuelTypesApiResponse =
  /** status 200 A successful response. */ VehicleOperationV1GetVehicleOperationFuelTypesRes;
export type VehicleOperationServiceV1GetVehicleOperationFuelTypesApiArg = void;
export type VehicleOperationServiceV1GetVehicleOperationTripTypesApiResponse =
  /** status 200 A successful response. */ VehicleOperationV1GetVehicleOperationTripTypesRes;
export type VehicleOperationServiceV1GetVehicleOperationTripTypesApiArg = {
  vehicleTypeId?: string;
};
export type VehicleOperationServiceV1GetVehicleOperationVehicleAuxiliariesApiResponse =
  /** status 200 A successful response. */ VehicleOperationV1GetVehicleOperationVehicleAuxiliariesRes;
export type VehicleOperationServiceV1GetVehicleOperationVehicleAuxiliariesApiArg =
  void;
export type VehicleOperationServiceV1GetVehicleOperationVehicleModelsApiResponse =
  /** status 200 A successful response. */ VehicleOperationV1GetVehicleOperationVehicleModelsRes;
export type VehicleOperationServiceV1GetVehicleOperationVehicleModelsApiArg = {
  vehicleTypeId?: string;
};
export type VehicleOperationServiceV1GetVehicleOperationVehicleTypesApiResponse =
  /** status 200 A successful response. */ VehicleOperationV1GetVehicleOperationVehicleTypesRes;
export type VehicleOperationServiceV1GetVehicleOperationVehicleTypesApiArg =
  void;
export type VehicleOperationServiceV1GetVehicleOperationApiResponse =
  /** status 200 A successful response. */ VehicleOperationV1VehicleOperationDetailRes;
export type VehicleOperationServiceV1GetVehicleOperationApiArg = {
  id: string;
};
export type VehicleOperationServiceV1UpdateVehicleOperationApiResponse =
  /** status 200 A successful response. */ VehicleOperationV1VehicleOperationMessageRes;
export type VehicleOperationServiceV1UpdateVehicleOperationApiArg = {
  id: string;
  vehicleOperationServiceV1UpdateVehicleOperationBody: VehicleOperationServiceV1UpdateVehicleOperationBody;
};
export type VehicleOperationV1VehicleOperationRefItem = {
  id?: string;
  name?: string;
};
export type VehicleOperationV1VehicleOperationRes = {
  id?: string;
  vehicle_type?: VehicleOperationV1VehicleOperationRefItem;
  vehicle_model?: VehicleOperationV1VehicleOperationRefItem;
  fuel_type?: VehicleOperationV1VehicleOperationRefItem;
  trip_type?: VehicleOperationV1VehicleOperationRefItem;
  fuel_usage?: number;
  avg_speed?: number;
  rest_hours?: number;
  working_hours?: number;
  status?: string;
  created_by?: string;
  updated_by?: string;
  created_at?: string;
  updated_at?: string;
};
export type VehicleOperationV1VehicleOperationPaginationMeta = {
  total?: number;
  current_page?: number;
  limit?: number;
  total_item?: number;
  total_page?: number;
  have_next_page?: boolean;
  have_previous_page?: boolean;
};
export type VehicleOperationV1ListVehicleOperationsRes = {
  vehicle_operations?: VehicleOperationV1VehicleOperationRes[];
  metadata?: VehicleOperationV1VehicleOperationPaginationMeta;
};
export type ProtobufAny = {
  "@type"?: string;
  [key: string]: any;
};
export type RpcStatus = {
  code?: number;
  message?: string;
  details?: ProtobufAny[];
};
export type VehicleOperationV1VehicleOperationMessageRes = {
  message?: string;
};
export type VehicleOperationV1CreateVehicleOperationItem = {
  vehicle_type_id: string;
  vehicle_model_id: string;
  fuel_type_id: string;
  vehicle_attachment_ids?: string[];
  trip_type_id: string;
  fuel_usage: number;
  avg_speed: number;
  rest_hours: number;
  working_hours: number;
  status: string;
};
export type VehicleOperationV1BatchCreateVehicleOperationReq = {
  vehicle_operations: VehicleOperationV1CreateVehicleOperationItem[];
};
export type VehicleOperationV1VehicleOperationBulkStatusChangeRes = {
  message?: string;
  updated_count?: number;
};
export type VehicleOperationV1VehicleOperationBulkStatusChangeReq = {
  ids: string[];
};
export type VehicleOperationV1GetVehicleOperationFuelTypesRes = {
  fuel_types?: VehicleOperationV1VehicleOperationRefItem[];
};
export type VehicleOperationV1GetVehicleOperationTripTypesRes = {
  trip_types?: VehicleOperationV1VehicleOperationRefItem[];
};
export type VehicleOperationV1GetVehicleOperationVehicleAuxiliariesRes = {
  vehicle_auxiliaries?: VehicleOperationV1VehicleOperationRefItem[];
};
export type VehicleOperationV1GetVehicleOperationVehicleModelsRes = {
  vehicle_models?: VehicleOperationV1VehicleOperationRefItem[];
};
export type VehicleOperationV1GetVehicleOperationVehicleTypesRes = {
  vehicle_types?: VehicleOperationV1VehicleOperationRefItem[];
};
export type VehicleOperationV1VehicleOperationDetailRes = {
  id?: string;
  vehicle_type?: VehicleOperationV1VehicleOperationRefItem;
  vehicle_model?: VehicleOperationV1VehicleOperationRefItem;
  fuel_type?: VehicleOperationV1VehicleOperationRefItem;
  vehicle_attachments?: VehicleOperationV1VehicleOperationRefItem[];
  trip_type?: VehicleOperationV1VehicleOperationRefItem;
  fuel_usage?: number;
  avg_speed?: number;
  rest_hours?: number;
  working_hours?: number;
  status?: string;
  created_by?: string;
  updated_by?: string;
  created_at?: string;
  updated_at?: string;
};
export type VehicleOperationServiceV1UpdateVehicleOperationBody = {
  vehicle_type_id: string;
  vehicle_model_id: string;
  vehicle_attachment_ids?: string[];
  trip_type_id: string;
  fuel_usage: number;
  avg_speed: number;
  rest_hours: number;
  working_hours: number;
};
export const {
  useVehicleOperationServiceV1ListVehicleOperationsQuery,
  useVehicleOperationServiceV1BatchCreateVehicleOperationMutation,
  useVehicleOperationServiceV1ActivateVehicleOperationsMutation,
  useVehicleOperationServiceV1DeactivateVehicleOperationsMutation,
  useVehicleOperationServiceV1GetVehicleOperationFuelTypesQuery,
  useVehicleOperationServiceV1GetVehicleOperationTripTypesQuery,
  useVehicleOperationServiceV1GetVehicleOperationVehicleAuxiliariesQuery,
  useVehicleOperationServiceV1GetVehicleOperationVehicleModelsQuery,
  useVehicleOperationServiceV1GetVehicleOperationVehicleTypesQuery,
  useVehicleOperationServiceV1GetVehicleOperationQuery,
  useVehicleOperationServiceV1UpdateVehicleOperationMutation,
} = injectedRtkApi;
